export enum ProductStatus {
  STOCK = 'В наличии',
  NOT_AVAILABLE = 'Нет в наличии',
  ORDER = 'Под заказ',
  NOT_FOUND = 'Не найден',
}